module.exports = __webpack_public_path__ + "img/881232090.193356a8.jpg";